import { render, staticRenderFns } from "./ScheduleCalenderContext.vue?vue&type=template&id=804739aa&"
import script from "./ScheduleCalenderContext.vue?vue&type=script&lang=js&"
export * from "./ScheduleCalenderContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScheduleCalenderItem: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/ScheduleCalendar/ScheduleCalenderItem.vue').default})
